import { Component, Input } from '@angular/core';

@Component({
  selector: 'nns-button',
  template: `
    <span class="nns-button-layout" flex layout="row" layout-align="center center">
      <span
        *ngIf="text" flex="none" class="nns-button-text"
      >{{text}}</span>
      <nns-icon *ngIf="icon" [icon]="icon"></nns-icon>
    </span>
  `,
  styles: [`
    :host {
      display:inline-block;
      vertical-align:top;
      position:relative;
      background:#0096a5;
      text-align:center;
      border:none;
      color:#fff;
      cursor:pointer;
      padding:0 4px;
      margin:0;
      border-radius:2px;
      font-size:12px;
      box-sizing:border-box;
      font-weight:bold;
      text-transform:uppercase;
      transition:all 0.1s ease-out;
    }
    .nns-button-layout {height:36px;}
    .nns-button-text {
      padding:0 12px;
      white-space:nowrap;
    }
    :host:hover,
    :host:focus {background:#148599;}
    :host /deep/ nns-icon {
      min-width:16px;
      min-height:16px;
    }
    :host .nns-button-toggle-icon {display:none;}
    :host .nns-button-toggle-icon nns-icon,
    :host .nns-button-active-icon nns-icon {display:block;}
    :host.nns-button-active .nns-button-toggle-icon {display:block;}
    :host.nns-button-active .nns-button-active-icon {display:none;}

    :host.secondary {background:#414b4c;}
    :host.secondary:hover,
    :host.secondary:focus {background:#000;}

    :host.medium .nns-button-layout {height:44px;}

    :host.icon {padding:0;}
    :host.icon .nns-button-layout {height:auto;}

    :host.transparent {background:none;}
    :host.transparent:hover,
    :host.transparent:focus {background:rgba(0,0,0, 0.1);}

    :host.disabled {background:rgba(0,0,0, 0.2); cursor:auto;}
    :host.disabled:hover,
    :host.disabled:focus {background:rgba(0,0,0, 0.2);}

    :host.text-colored {color:#0095A7; background:none;}
    :host.text-colored:hover,
    :host.text-colored:focus {background:rgba(0, 149, 167, 0.1);}

    :host.full-width {width:100%; display: block;}
  `, `
    :host-context(.nns-theme-night).secondary {
      background:#000;
    }
    :host-context(.nns-theme-night).text-colored {
      color:#0095A7;
      background:none;
    }
    :host-context(.nns-theme-night).text-colored:hover,
    :host-context(.nns-theme-night).text-colored:focus {
      background:rgba(181,181,181,0.10);
    }
  `]
})

export class ButtonComponent {
  @Input() text;
  @Input() icon;
}
